export { PageStaticsComponent as PageStatics } from './component';



// WEBPACK FOOTER //
// ./src/pages/statics/index.tsx